module.exports = __webpack_public_path__ + "static/BarlowCondensed-Bold-cf45e631fedca01e1f569cfb43eff20e.ttf";